import Collapse from "@mui/material/Collapse";
import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import PrintOptionAttributeComments from "./PrintOptionAttributeComments";
import PrintOptionAutoScale from "./PrintOptionAutoScale";
import PrintOptionPageHeader from "./PrintOptionPageHeader";
import PrintOptionPaperSizeAndOrientation from "./PrintOptionPaperSizeAndOrientation";

const DefaultPrintOptions: FunctionComponent = observer(function DefaultPrintOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		hasPrintOptions,
		printOptionsCollapse,
		toggleCollapsedPrintOptions,
	} = optionsStore;

	if (!hasPrintOptions) {
		return;
	}

	return (
		<CustomViewOptionCustomSection
			collapsed={printOptionsCollapse}
			dataCsiAutomation="DefaultPrintOptions"
			onCollapse={toggleCollapsedPrintOptions}
			titleRes="CustomViewPrintOptions"
		>
			<Collapse in={!printOptionsCollapse} timeout="auto">
				<PrintOptionPaperSizeAndOrientation />
				<PrintOptionPageHeader />
				<PrintOptionAttributeComments />
				<PrintOptionAutoScale />
			</Collapse>
		</CustomViewOptionCustomSection>
	);
});

export default DefaultPrintOptions;